export const FOOTER_TOOLBAR = 'footer-toolbar';
